<script setup lang="ts">
import { computed } from 'vue';

import { locale } from '@/locale';
import { analytics } from '@/scitylana';

import TruButton from '../TruButton.vue';
import TruCard from '../TruCard.vue';

import petAndPublicHealthLogo from '@/assets/images/petAndPublicHealthLogo.svg';
import petAndPublicHealthLogoEnCa from '@/assets/images/petAndPublicHealthLogo_en-CA.svg';
import petAndPublicHealthLogoFrCa from '@/assets/images/petAndPublicHealthLogo_fr-CA.svg';
import petAndPublicHealthLogoSpUs from '@/assets/images/petAndPublicHealthLogo_es-US.svg';

const logoFileName = computed(() => {
    switch (locale.value) {
        case 'en-CA':
            return petAndPublicHealthLogoEnCa;
        case 'fr-CA':
            return petAndPublicHealthLogoFrCa;
        case 'es-US':
            return petAndPublicHealthLogoSpUs;
        default:
            return petAndPublicHealthLogo;
    }
});

function gotoPetAndPublicHealth() {
    analytics.home.petAndPublicHealth();

    // eslint-disable-next-line vue/max-len
    window.open('https://petpublichealth.org/?utm_campaign=pphewds&utm_medium=vet-portal&utm_source=vet&utm_content=widget');
}
</script>

<template>
    <div class="pet-and-public-health">
        <TruCard>
            <div class="flex">
                <div class="left flex flex-col mr-10">
                    <img
                        :src="logoFileName"
                        class="mb-4"
                        :alt="$t('dashboard.petAndPublicHealth.logoAlt')"
                    >

                    <div class="body mb-6">
                        <I18nT
                            keypath="dashboard.petAndPublicHealth.body"
                            tag="span"
                        >
                            <template #boldText>
                                <strong>{{ $t('dashboard.petAndPublicHealth.boldText') }}</strong>
                            </template>
                        </I18nT>
                    </div>

                    <TruButton
                        secondary
                        size="xs"
                        @click="gotoPetAndPublicHealth"
                    >
                        {{ $t('dashboard.petAndPublicHealth.button') }}
                    </TruButton>
                </div>

                <div class="right flex justify-start items-center">
                    <img src="../../assets/images/petAndPublicHealthDoppler.png">
                </div>
            </div>
        </TruCard>
    </div>
</template>

<style scoped lang="scss">
.pet-and-public-health {
    img[src*=petAndPublicHealthLogo] {
        width: 205px;
    }

    img[src*=petAndPublicHealthLogo_es-US] {
        width: 250px;
    }

    img[src*=petAndPublicHealthLogo_en-CA],
    img[src*=petAndPublicHealthLogo_fr-CA] {
        width: 240px;
    }
}

@media screen and (max-width:1300px) {
    .pet-and-public-health {
        .left {
            flex: 1;
            min-width: 0;
        }

        .right {
            flex-shrink: 0;
            width: 30%;

            img {
                max-width: 100%;
            }
        }
    }
}
</style>
